import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateModule } from '@ngx-translate/core';
import { ComponentsModule } from '@common/components/components.module';
import { AuthGuardService } from '@common/services/AuthGuardService/AuthGuardService';
import { ContainerComponent } from './views/container.component';
import { TopBarComponent } from './views/TopBarComponent/topBar.component';
import { TopMenuComponent } from './views/TopMenuComponent/topMenu.component';
import { DashboardViewComponent } from '@modules/dashboard/views/dashboardView/dashboardView.component';
import { EmployeesViewComponent } from '@modules/employees/views/employeesView/employeesView.component';
import { ClientsViewComponent } from '@modules/clients/views/clientsView/clientsView.component';
import { EmployeeDetailsViewComponent } from '@modules/employees/views/employeeDetailsView/employeeDetailsView';
import { ClientDetailsViewComponent } from '@modules/clients/views/clientDetailsView/clientDetailsView';
import { AreaDetailsViewComponent } from '@modules/clients/views/areaDetailsView/areaDetailsView';
import { TaskDetailsViewComponent } from '@modules/clients/views/taskDetailsView/taskDetailsView.component';
import { AddEditEmployeeViewComponent } from '@modules/employees/views/addEditEmployeeView/addEditEmployeeView.component';
import { AddEditTaskViewComponent } from '@modules/clients/views/addEditTaskView/addEditTaskView.component';
import { ProgressInAreaViewComponent } from '@modules/clients/views/progressInAreaView/progressInAreaView';

const routes: Routes = [
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
  {
    path: '',
    canActivate: [AuthGuardService],
    component: ContainerComponent,
    children: [
      { path: 'dashboard', canActivate: [AuthGuardService], component: DashboardViewComponent },
      { path: 'employees', canActivate: [AuthGuardService], component: EmployeesViewComponent },
      { path: 'employees/addEmployee', canActivate: [AuthGuardService], component: AddEditEmployeeViewComponent },
      { path: 'employees/:employeeKey', canActivate: [AuthGuardService], component: EmployeeDetailsViewComponent },
      { path: 'employees/:employeeKey/edit', canActivate: [AuthGuardService], component: AddEditEmployeeViewComponent },
      { path: 'clients', canActivate: [AuthGuardService], component: ClientsViewComponent },
      { path: 'clients/:clientKey', canActivate: [AuthGuardService], component: ClientDetailsViewComponent },
      { path: 'clients/:clientKey/:areaKey', canActivate: [AuthGuardService], component: AreaDetailsViewComponent },
      { path: 'clients/:clientKey/:areaKey/progressInArea', canActivate: [AuthGuardService], component: ProgressInAreaViewComponent },
      { path: 'clients/:clientKey/:areaKey/addTask', canActivate: [AuthGuardService], component: AddEditTaskViewComponent },
      { path: 'clients/:clientKey/:areaKey/:taskKey', canActivate: [AuthGuardService], component: TaskDetailsViewComponent },
      { path: 'clients/:clientKey/:areaKey/:taskKey/edit', canActivate: [AuthGuardService], component: AddEditTaskViewComponent },
    ],
  },
];

@NgModule({
  declarations: [
    ContainerComponent,
    TopBarComponent,
    TopMenuComponent,
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    BrowserAnimationsModule,
    TranslateModule,
    ComponentsModule,
  ],
  exports: [
    RouterModule,
  ],
})
export class ContainerModule { }



// WEBPACK FOOTER //
// ./src/app/modules/container/container.module.ts